import classnames from 'classnames';
import { format } from 'date-fns';
import { FC } from 'react';
import DatePicker, { ReactDatePickerProps } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FieldRenderProps } from 'react-final-form';

import { parseDateForPicker } from '../../../utilities/parseDateForPicker';

type FormDateFieldProps = ReactDatePickerProps &
  FieldRenderProps<string, HTMLElement, string> & {
    value: string;
    labelText: string;
  };

const FormDateField: FC<FormDateFieldProps> = ({
  input,
  labelText,
  meta: { touched, error },
  ...props
}) => {
  const includeLabel = labelText || !props.ariaLabelledBy;
  return (
    <>
      {includeLabel && (
        <label
          htmlFor={input.name}
          className={classnames('text-sm text-primaryGray', {
            'sr-only': !labelText,
          })}
        >
          {labelText || input.name}
        </label>
      )}
      <div className="relative">
        <DatePicker
          id={input.name}
          selected={parseDateForPicker(input.value)}
          className="block w-full rounded-md border border-gray-300 bg-white py-2 pr-3 text-sm shadow-sm"
          dateFormat="M/d/y"
          wrapperClassName="w-full"
          {...props}
          onChange={(date: Date) => {
            if (!date) {
              input.onChange(undefined);
              return;
            }
            input.onChange(format(date, 'yyyy-MM-dd'));
          }}
        />
      </div>
      {touched && error && (
        <span className="text-xs text-red-800">{error}</span>
      )}
    </>
  );
};

export default FormDateField;
